import {axios} from "~/plugins/axios";

const getDefaultState_formStatisticReport = () => {
  return {
    report: {},
  }
}
const state = getDefaultState_formStatisticReport();

const getters = {
  report: state => state.report,
}

const actions = {
  async loadFormStatisticReport({ commit }, payload) {
    commit('shared/SET_LOADING', true, {root: true})
    let headers = {}

    try {
      if (payload.excel === true) {
        headers = {
          responseType: "blob",
        }
      }

      let resp = await axios.post('/api/reports/helpers/users-cards-calls', payload, headers)

      if (payload.excel === true) {
        this._vm.utils.downloadXlsx(resp)
      }

      commit('shared/SET_LOADING', false, {root: true})

      return resp.data

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

  async loadXlsxReport(ctx, payload) {
    try {
      payload.excel = true
      let resp = await axios.post('/api/reports/helpers/users-cards-calls', payload, {responseType: "blob"})
      this._vm.utils.downloadXlsx(resp)
    } catch (err) {
      console.log(err);
    }
  }
}

const mutations = {
  SET_REPORT(state, items) {
    state.report = items;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
